import React from 'react';
import {Container, Row, Col} from 'reactstrap';

import '../debtPayment.scss';
import BasicText from './basicText';

const PaymentNotification = (props) => {
  let creditPaymentText = '';
  if (props.numOfPayments !== undefined || props.numOfPayments !== '') {
    if (props.numOfPayments === '1') {
      creditPaymentText = 'תשלום אחד';
    } else {
      creditPaymentText = 'תשלום ב-' + props.numOfPayments + ' תשלומים';
    }
  }

  return (
    <Container className='debtpayment-notification-container'>
      <Row className=''>
        <Col md='auto' className={''}>
          <Row className='debtpayment-authnumber'>
            <Col>
              <BasicText text={'מספר אמסכתא: ' + props.authNumber} bold />
            </Col>
          </Row>
          <Row>
            <Col className='debtpayment-margintop'>
              <BasicText text={'שולם ' + '₪' + props.amount} bold />
            </Col>
          </Row>
          <Row>
            <Col>
              <BasicText text={creditPaymentText} />
            </Col>
          </Row>
          <Row className='debtpayment-margintop'>
            <Col>
              <BasicText text='אישור על התשלום יופיע בחשבונית הקרובה' />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentNotification;
